document.addEventListener("DOMContentLoaded", () => {
  const addBtn = document.querySelector(".hdt-product-form__buttons button[type='submit'], .hdt-product-form__buttons input[type='submit']");
  const garantiaRadios = document.querySelectorAll("input[name='garantia_extendida']");

  if (!addBtn) return;

  addBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    //Obtener el variantId del producto principal
    const productForm = e.target.closest("form");
    if (!productForm) return;

    const formData = new FormData(productForm);
    const variantId = formData.get("id"); 
    const requestedQuantity = Math.max(1, parseInt(formData.get("quantity"), 10) || 1);

    if (!variantId) {
      console.error("No se encontró el ID de la variante principal");
      return;
    }

    // 🚫 Verificar si el producto principal ya está en el carrito con garantía
    try {
      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();

      const yaExiste = cartData.items.some(item => {
        // Verifica si este producto ya está agregado
        if (item.variant_id.toString() === variantId.toString()) {
          // Y además tiene una garantía asociada
          const tieneGarantia = cartData.items.some(
            g => g.properties && g.properties.main_product_id === item.variant_id.toString()
          );
          return tieneGarantia;
        }
        return false;
      });

      if (yaExiste) {
        mostrarPopupProductoExistente();
        return; // 🚫 Detenemos aquí: no agrega nada
      }
    } catch (err) {
      console.error("⚠️ Error verificando si el producto ya existe:", err);
    }

    //Detectar si hay una garantía seleccionada
    const garantiaSeleccionada = Array.from(garantiaRadios).find(radio => radio.checked);
    
    let garantiaVariantId = null;

    if (garantiaSeleccionada) {
      garantiaVariantId = garantiaSeleccionada.dataset.variantId;
    }
    try {
      //1. Agregar producto principal
      await addToCart(variantId, requestedQuantity);

      // 2. Agregar garantía si aplica
      if (garantiaVariantId) {
        await addToCart(garantiaVariantId, 1, true, variantId);
      }

    } catch (error) {
      console.error("Error al agregar productos:", error);
    }
  });

  async function addToCart(variantId, quantity = 1, isWarranty = false, mainVariantId = null) {
    try {
      const bodyData = { id: variantId, quantity: Math.max(1, parseInt(quantity, 10) || 1) };
      if (isWarranty && mainVariantId) {
        bodyData.properties = { main_product_id: mainVariantId };
      }
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(bodyData)
      });

      const cartRes = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      const cartData = await cartRes.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));

    } catch (err) {
      console.error("Error al agregar:", err);
      throw err;
    }
  }
});


